export const environment = {
  production: true,
  apiUrl: 'https://askafox.com:8443/askafox-ws',
  domain: 'askafox.com'
};
